/* 
Componente para mostrar los movimientos MovRedem de Ilusiona de cada usuario.
 */

import React, { useEffect, useState } from "react";

//CONSTANTS
import FORMATNUMBER from "../constants";

//COMPONENTS
import TablePaginationActions from "./TablePaginationActions";

//REDUX
import { useDispatch } from "react-redux";
import { getListMovementAction } from "../redux/actions/movementActions";
import { setPointsAction } from "../redux/actions/userActions";

//#region CSS
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";

import CircularProgress from "@material-ui/core/CircularProgress";

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#363636",
    color: theme.palette.common.white,
    fontSize: "1.10rem"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);
const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 700
  },
  progress: {
    width: "100%",
    marginTop: "50px",
    marginBottom: "50px",
    textAlign: "center"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    padding: "20px"
  }
}));
//#endregion

export default function TableMovements({ userId }) {
  const classes = useStyles();

  //#region Values
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  //#endregion

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  //#endregion

  //#region HandleChange
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  //#endregion

  useEffect(() => {
    setLoading(true);
    const setPoints = userId => dispatch(setPointsAction(userId));
    setPoints(userId);
    const getListMovement = userId => dispatch(getListMovementAction(userId));
    getListMovement(userId)
      .then(data => {
        setRows(data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setError(true);
      });
  }, [dispatch, userId]);

  return (
    <TableContainer component={Paper}>
      {loading ? (
        <div className={classes.progress}>
          <CircularProgress color="secondary" size={60} />
        </div>
      )
        : error ?
          <Grid item xs={12}>
            <Box textAlign="center">
              <Typography
                className={classes.heading}
                data-lang="movements_error"
              >
                Hay un problema con el servidor, pruebe más tarde. Perdone las molestias.
        </Typography>
            </Box>
          </Grid>
          : rows.length === 0 ?
            (
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Typography
                    className={classes.heading}
                    data-lang="movements_no_results"
                  >
                    No hay movimientos
            </Typography>
                </Box>
              </Grid>
            ) : (
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell data-lang="movements_table_date">Fecha</StyledTableCell>
                    <StyledTableCell data-lang="movements_table_center">Centro</StyledTableCell>
                    <StyledTableCell data-lang="movements_table_description">Descripción</StyledTableCell>
                    <StyledTableCell data-lang="movements_table_detail">Detalles</StyledTableCell>
                    <StyledTableCell data-lang="movements_table_points">Puntos</StyledTableCell>
                    <StyledTableCell data-lang="movements_table_balance">Saldo</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : rows
                  ).map(row => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell>{row.date}</StyledTableCell>
                      <StyledTableCell>{row.center}</StyledTableCell>
                      <StyledTableCell>{row.description}</StyledTableCell>
                      <StyledTableCell>{row.detail}</StyledTableCell>
                      <StyledTableCell align="center">{FORMATNUMBER(row.point)}</StyledTableCell>
                      <StyledTableCell align="center">{FORMATNUMBER(row.balance)}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: <span data-lang="movements_all">Todas</span>, value: -1 }]}
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            )}
    </TableContainer>
  );
}
